import { useLanguage } from 'app/shared'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { RootState } from 'root-reducer'
import { setModalOpen } from 'store'
import { OutlineButton, RoundedButton, Text } from 'ui/components'
import { styled } from 'ui/styles'

import { ModalTemplate } from './templates'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 370px;
  justify-content: space-between;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
`

const Status = styled(Text)``
const StatusInfo = styled(Text)`
  margin-bottom: 32px;
`

const Header = styled.span`
  display: inline-flex;
  justify-content: flex-end;
  width: 100%;
`

const HEADER_SUCCESS = ['Спасибо!', 'Thank you!']
const HEADER_ERROR = ['Упс!', 'Oops!']

const DESCRIPTION_SUCCESS = ['Мы скоро свяжемся с вами', 'We will contact you soon']
const DESCRIPTION_ERROR = ['Что-то пошло не так', 'Something went wrong']

const SUBMIT_LABEL = ['Хорошо', 'OK']

export const StatusModal = () => {
  const modalState = useSelector((state: RootState) => state.modal)
  const dispatch = useDispatch()
  const { languageState } = useLanguage()

  const isError = modalState.modalType?.status?.isError

  const onClose = () => {
    dispatch(setModalOpen({ modalIsOpen: false }))
  }

  return (
    <ModalTemplate onClose={onClose}>
      <Wrapper>
        <Content>
          <Header>
            <RoundedButton onClick={onClose} isOutline />
          </Header>
          <Status variant="h5" color="black">
            {isError ? `${HEADER_ERROR[languageState.number]}` : `${HEADER_SUCCESS[languageState.number]}`}
          </Status>
          <StatusInfo variant="h5" color="black" align="center">
            {isError ? `${DESCRIPTION_ERROR[languageState.number]}` : `${DESCRIPTION_SUCCESS[languageState.number]}`}
          </StatusInfo>
          {isError && (
            <Text variant="t2" color="black">
              {modalState.modalType?.status?.message}
            </Text>
          )}
        </Content>
        <OutlineButton onClick={onClose}>{SUBMIT_LABEL[languageState.number]}</OutlineButton>
      </Wrapper>
    </ModalTemplate>
  )
}
